module.exports = __webpack_public_path__ + "static/media/MasrafFisleri.5a440683.png";